import { render } from "./BackToSearch.vue?vue&type=template&id=9b163e26"
import script from "./BackToSearch.vue?vue&type=script&lang=js"
export * from "./BackToSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__